import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrinterHeaderComponent } from './printersettings/printer-header/printer-header.component';
import { PrinterFooterComponent } from './printersettings/printer-footer/printer-footer.component';
import { PrintingListComponent } from './printersettings/printing-list/printing-list.component';
import { SignatureComponent } from './signature/signature.component';
import { PageSpinnerComponent } from './page-spinner/page-spinner.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { TakePhotoComponent } from './take-photo/take-photo.component';
import { NbAutocompleteModule, NbButtonModule, NbIconModule, NbPopoverModule, NbSelectModule, NbTabsetModule, NbTooltipModule } from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ng2-ckeditor';
import {OwlDateTimeModule} from 'ng-pick-datetime';
import { OwlNativeDateTimeModule} from 'ng-pick-datetime';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarDateFormatter, CalendarModule  } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { FlatpickrModule } from 'angularx-flatpickr';
import { momentAdapterFactory } from '../../../pages/patient-portal/patient-portal.module';
import { CustomWeekView } from './angular-calender/custom-week-view.component';
import { DateAdapter } from '@angular/material/core/datetime/date-adapter';
import { CalendarHeaderComponent } from './angular-calender/calendar-header.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import {MatTableDataSource} from '@angular/material/table';
import { NgxChartsModule } from '@swimlane/ngx-charts';

// virtual select declare
import { MatSelectModule } from '@angular/material/select'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { DemoUtilsModule } from './angular-calender/calenderUtil.module';

import { KeyboardShortcutsModule }     from 'ng-keyboard-shortcuts';
import { PatientQuickSearchComponent } from './patient-quick-search/patient-quick-search.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { NgxPaginationModule } from 'ngx-pagination';
import { AlphabetFilterComponent } from './alphabet-filter/alphabet-filter.component';
import { SequenceTemplateComponent } from '../../../pages/Masters/sequence-template/sequence-template.component';
import { NgxSelectModule } from 'ngx-select-ex';
import { ComponentsModule } from '../../../@components/components.module';

// For Multi Language Translation Purpose:-
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule,HttpClient } from '@angular/common/http';
import { EzoCaptchaComponent } from './ezo-captcha/ezo-captcha.component';

// For captcha:-
import {EzoCaptchaModule} from './ezo-captcha/ezo-captcha.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TemplatePreviewComponent } from './template-preview/template-preview.component';
import { NgxPrintElementModule } from 'ngx-print-element';
import { EzoTexttoSpeechServiceComponent } from './service/ezo-textto-speech-service.component';
import { NgxPrintModule } from 'ngx-print';
import { AptOpdLogService } from '../../../@core/backend/common/services/apt-opd-log.service';
import { StickersComponent } from './stickers/stickers.component';
import { StickersPrintComponent } from './stickers-print/stickers-print.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { BedDashboardWardBedPrintComponent } from './bed-dashboard-ward-bed-print/bed-dashboard-ward-bed-print.component';
import { PrescriptionPrintTemplateComponent } from './prescription-print-template/prescription-print-template.component';
import { ExternalDoctorAddComponent } from './external-doctor-add/external-doctor-add.component';
import { NewAttachmentComponent } from './new-attachment/new-attachment.component';
import { StickersTemplateComponent } from './stickers-template/stickers-template.component';
import { CommonPatientListComponent } from './common-patient-list/common-patient-list.component';
import { CommonTemplatePrintComponent } from './common-template-print/common-template-print.component';
import { LabReportsComponent } from './lab-reports/lab-reports.component';
import { RadiologyComponent } from './radiology/radiology.component';
import { RadiologyCompareComponent } from './radiology-compare/radiology-compare.component';
import { RadiologyPrintComponent } from './radiology-print/radiology-print.component';
import { RadiologySummaryTemplateComponent } from '../../../pages/EHR/radiology-summary-template/radiology-summary-template.component';
import { IpNurseIndentComponent } from './ip-nurse-indent/ip-nurse-indent.component';
import { IndentCommonPrintComponent } from './indent-common-print/indent-common-print.component';
import { OpdslipTemplateThermalPrintComponent } from '../../../pages/PatientServices/opdslip-template-thermal-print/opdslip-template-thermal-print.component';

import { DicomViewerModule } from '../../../pages/dicom-viewer/dicom-viewer.module';
 import { AdmissionreferralComponent } from '../common/admissionreferral/admissionreferral.component';
import { CounsellingComponent } from '../common/counselling/counselling.component';
import { PatientLogReportComponent } from './patient-log-report/patient-log-report.component';
import { PatientLogReportPrintComponent } from './patient-log-report-print/patient-log-report-print.component';
import { ChatboxcompComponent } from './chatboxcomp/chatboxcomp.component';
import { AudioCallConsultComponent } from './audio-call-consult/audio-call-consult.component';
import { ReviewTestComponent } from './review-test/review-test.component';
import { PolicyHeaderDetailsComponent } from './policy-header-details/policy-header-details.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { AssesmentComponent } from './assesment/assesment.component';
import { EhrComponent } from './ehr/ehr.component';
import { Ecg12LeadStaticWaveformComponent } from './ecg12-lead-static-waveform/ecg12-lead-static-waveform.component';
import { ErRequestReferralComponent } from './er-request-referral/er-request-referral.component';  
import { SymptomCheckerComponent } from './symptom-checker/symptom-checker.component';
import { MatSliderModule } from '@angular/material/slider';
import { SymptomCheckerResultComponent } from './symptom-checker-result/symptom-checker-result.component';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
const COMPONENTS = [
  AssesmentComponent,
  AudioCallConsultComponent,
  ChatboxcompComponent,
  PatientLogReportPrintComponent,
  PatientLogReportComponent,
  CounsellingComponent,
  ReviewTestComponent,
  AdmissionreferralComponent,
  CommonTemplatePrintComponent,
  OpdslipTemplateThermalPrintComponent,
  CommonPatientListComponent,
  ExternalDoctorAddComponent,
  PrinterHeaderComponent,
  PrinterFooterComponent,
  SignatureComponent,
  PrintingListComponent,
  PageSpinnerComponent,
  TakePhotoComponent,
  CustomWeekView,
  CalendarHeaderComponent,
  PatientQuickSearchComponent,
  AlphabetFilterComponent,
  SequenceTemplateComponent,
  TemplatePreviewComponent,
  NewAttachmentComponent,IpNurseIndentComponent,
  EzoTexttoSpeechServiceComponent,StickersComponent,StickersPrintComponent,BedDashboardWardBedPrintComponent,PrescriptionPrintTemplateComponent,StickersTemplateComponent,
  LabReportsComponent,RadiologyComponent,RadiologyCompareComponent,RadiologyPrintComponent,RadiologySummaryTemplateComponent, PolicyHeaderDetailsComponent
  ,EhrComponent,ErRequestReferralComponent,SymptomCheckerComponent,SymptomCheckerResultComponent,Ecg12LeadStaticWaveformComponent
];
const MODULE=[
  NgxChartsModule,
  NgxSpinnerModule,
  NbButtonModule,
  NbIconModule,
  FormsModule,
  NbSelectModule,
  NbPopoverModule,
  ReactiveFormsModule,
  CKEditorModule,
  MatSelectModule,
  NgxMatSelectSearchModule,
  MatSliderModule,
  MatIconModule,
  MatToolbarModule,
  MatCardModule,
  MatDividerModule,
  MatProgressSpinnerModule,
  MatSelectInfiniteScrollModule,
  KeyboardShortcutsModule,
  NbAutocompleteModule,
  NgxPaginationModule,
  Ng2SearchPipeModule,
  NgxSelectModule,
  ComponentsModule,
  HttpClientModule,
  EzoCaptchaModule,
  MatSnackBarModule,NgxBarcodeModule,NbTabsetModule,NgSelectModule,
  TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    }
  }),
  NbTooltipModule,
  NgxPrintElementModule,
  NgxPrintModule,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  DicomViewerModule
]
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [...COMPONENTS, IndentCommonPrintComponent],
  exports: [...COMPONENTS,TranslateModule,
    NgxSpinnerModule,HttpClientModule,
    NbIconModule,NbButtonModule,
    FormsModule,NbSelectModule,NbPopoverModule,ReactiveFormsModule,
    CKEditorModule,MatSelectModule,NgxMatSelectSearchModule,
    MatSliderModule,
    MatIconModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatSelectInfiniteScrollModule,
    KeyboardShortcutsModule,
    NbAutocompleteModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    NgxSelectModule,
    ComponentsModule,
    NgSelectModule,
    EzoCaptchaModule, NbTooltipModule, OwlDateTimeModule, OwlNativeDateTimeModule],
  imports: [
    CommonModule,...MODULE, CalendarModule
  ],
  providers:[AptOpdLogService]

})
export class UsecommonModule { }
